import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { UserContext } from '../../../auth/models/auth';
var ListMenuComponent = /** @class */ (function () {
    function ListMenuComponent() {
        this.onToggleNavBar = new EventEmitter();
        this.onToggleMobileUserOptions = new EventEmitter();
        this.onSelectCustomer = new EventEmitter();
        this.onItemClick = new EventEmitter();
        this.menuItemsExtended = [];
    }
    Object.defineProperty(ListMenuComponent.prototype, "topMenus", {
        get: function () {
            if (this.menuItems && this.menuItems.length > 0) {
                return this.menuItems.filter(function (menu) { return menu.parent === null; });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    ListMenuComponent.prototype.hasChildMenus = function (menuItem) {
        // Check if menu has children.
        if (menuItem.children && menuItem.children.length > 0) {
            // Menu item has children but they also need to be of the type 'top' or 'both.
            var children = this.menuItems.filter(function (menuItem) {
                return this.indexOf(menuItem.code) >= 0 && (menuItem.type === 'top' || menuItem.type === 'both');
            }, menuItem.children);
            return children.length > 0;
        }
        return false;
    };
    ListMenuComponent.prototype.getChildMenus = function (menuItem) {
        if (this.menuItems && this.menuItems.length > 0) {
            return this.menuItems.filter(function (item) {
                return this.indexOf(item.code) > -1;
            }, menuItem.children);
        }
        return [];
    };
    ListMenuComponent.prototype.getChildMenuGroups = function (menuItem) {
        var childMenuGroups = [];
        var nrOfGroups = Math.ceil(menuItem.children.length / 8);
        var startSlice = 0;
        var endSlice = 8;
        for (var i = 0; i < nrOfGroups; i++) {
            var childrenForGroup = menuItem.children.slice(startSlice, endSlice);
            if (childrenForGroup.length > 0) {
                var childGroup = { sortOrder: 1, children: childrenForGroup };
                childMenuGroups.push(childGroup);
                startSlice += 8;
                endSlice += 8;
            }
        }
        return childMenuGroups;
    };
    ListMenuComponent.prototype.onClickMenu = function (menu) {
        if (this.hasChildMenus(menu)) {
            this.toggleSubMenu();
        }
        else {
            this.toggleNavBar();
        }
    };
    ListMenuComponent.prototype.toggleNavBar = function () {
        this.toggleSubMenu();
        this.onToggleNavBar.emit();
    };
    ListMenuComponent.prototype.toggleMobileUserOptions = function () {
        this.onToggleMobileUserOptions.emit();
    };
    ListMenuComponent.prototype.toggleSubMenu = function (menu) {
        if (menu) {
            // First make other possible menus inactive
            var otherMenus = this.menuItemsExtended.filter((function (otherMenu) { return otherMenu._id !== menu._id; }));
            otherMenus.forEach(function (otherMenu) {
                otherMenu.isActive = false;
            });
            var menuItemExtended = this.menuItemsExtended.find(function (menuExtended) { return menuExtended._id === menu._id; });
            if (menuItemExtended) {
                menuItemExtended.isActive = !menuItemExtended.isActive;
            }
            else {
                var menuItemExtended_1 = tslib_1.__assign({}, menu, { isActive: true });
                this.menuItemsExtended.push(menuItemExtended_1);
            }
        }
        else {
            // Sub menu item clicked, emit this.
            this.onItemClick.emit();
            this.menuItemsExtended.forEach(function (menu) {
                menu.isActive = false;
            });
        }
    };
    ListMenuComponent.prototype.showSubMenu = function (menu) {
        if (this.menuItemsExtended.length) {
            var menuItemExtended = this.menuItemsExtended.find(function (menuExtend) { return menuExtend._id === menu._id; });
            if (menuItemExtended) {
                return menuItemExtended.isActive;
            }
        }
        return false;
    };
    return ListMenuComponent;
}());
export { ListMenuComponent };
